<template>
  <div class="container client">
    <div class="header card">
      <el-breadcrumb
        class="breadcrumb"
        separator="/"
      >
        <el-breadcrumb-item>选题</el-breadcrumb-item>
        <el-breadcrumb-item>创作中心</el-breadcrumb-item>
      </el-breadcrumb>
      <div class="content">
        <div class="left">
          <h2 class="title">创作中心</h2>
        </div>
        <div class="right">
          <el-button
            icon="el-icon-download"
            @click="handleExport"
            size="small"
          >导出</el-button>
          <el-button
            class="button"
            type="primary"
            @click="createDialog = true"
          >创建</el-button>
        </div>
      </div>
    </div>
    <div class="filters card">
      <el-form
        class="search-wrap"
        ref="searchForm"
        :inline="true"
        :model="query"
      >
        <el-form-item label="文案标题">
          <el-input
            v-model.trim="query.title_keyword"
            placeholder="输入文案标题"
            @input="fetchList(true)"
            clearable
          ></el-input>
        </el-form-item>
        <el-form-item label="所属选题">
          <el-input
            v-model.trim="query.topic_name_keyword"
            placeholder="输入所属选题"
            @input="fetchList(true)"
            clearable
          ></el-input>
        </el-form-item>
        <!--      <el-form-item label="是否排版">
          <el-select
            v-model="query.is_typeset"
            placeholder="请选择是否排版"
            @change="fetchList(true)"
            clearable
          >
            <el-option
              label="是"
              :value="1"
            >
            </el-option>
            <el-option
              label="否"
              :value="0"
            >
            </el-option>
          </el-select>
        </el-form-item> -->
        <el-form-item label="发布状态">
          <el-select
            v-model="query.publish_status"
            placeholder="请选择发布状态"
            @change="fetchList(true)"
            clearable
          >
            <el-option
              label="已发布"
              :value="1"
            >
            </el-option>
            <el-option
              label="未发布"
              :value="0"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="作者">
          <el-input
            v-model.trim="query.part_time_name_keyword"
            placeholder="输入作者"
            @input="fetchList(true)"
            clearable
          ></el-input>
        </el-form-item>
        <el-form-item label="发布账号">
          <el-input
            v-model.trim="query.publish_account_keyword"
            placeholder="输入发布账号"
            @input="fetchList(true)"
            clearable
          ></el-input>
        </el-form-item>
        <el-form-item label="预发日期">
          <el-date-picker
            class="datetime"
            v-model="pre_pub_time"
            type="datetimerange"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            @change="fetchList(true)"
            :default-time="['00:00:00', '23:59:59']"
            clearable
          >
          </el-date-picker>
        </el-form-item>
        <el-form-item label="创建时间">
          <el-date-picker
            class="datetime"
            v-model="create_time"
            type="datetimerange"
            :default-time="['00:00:00', '23:59:59']"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            @change="fetchList(true)"
            clearable
          >
          </el-date-picker>
        </el-form-item>
      </el-form>
    </div>
    <div class="results card">
      <div class="table-header">
        <h3 class="title">文案列表</h3>

      </div>
      <div class="values">
        <el-table
          class="table"
          :data="results"
          border
          style="width: 100%"
          @selection-change="handleSelectionChange"
        >
          <el-table-column
            type="selection"
            width="50"
            fixed="left"
          > </el-table-column>
          <el-table-column
            prop="id"
            label="ID"
            width="80"
            fixed="left"
            align="center"
            show-overflow-tooltip
          >
          </el-table-column>
          <el-table-column
            prop="title"
            label="文案标题"
            width="300"
            align="center"
            show-overflow-tooltip
          >
          </el-table-column>
          <el-table-column
            prop="topic_name"
            label="所属选题"
            width="120"
            align="center"
            show-overflow-tooltip
          >
          </el-table-column>
          <el-table-column
            prop="pre_pub_time"
            label="预发日期"
            width="160"
            align="center"
            show-overflow-tooltip
          >
            <template slot-scope="scope">
              <span>{{scope.row.pre_pub_time?
                $moment(scope.row.pre_pub_time).format("YYYY.MM.DD HH:mm"):""
              }}</span>
            </template>

          </el-table-column>
          <!--      <el-table-column
            label="是否排版"
            width="80"
            align="center"
            show-overflow-tooltip
          >
            <template slot-scope="scope">
              <el-link
                type="primary"
                :underline="false"
                v-if="scope.row.is_typeset==1"
                @click="handleToTypeset(scope.row,0,'是否设置为未排版')"
              >是</el-link>
              <el-link
                type="primary"
                :underline="false"
                v-else
                @click="handleToTypeset(scope.row,1,'是否设置为已排版')"
              >否</el-link>
            </template>
          </el-table-column> -->
          <el-table-column
            label="发布状态"
            width="100"
            show-overflow-tooltip
            align="center"
          >

            <template slot-scope="scope">
              <el-tag :type="scope.row.publish_status == 1 ? 'success' : 'danger'">{{
                scope.row.publish_status == 1 ? "已发布" : "未发布"
              }}</el-tag>
            </template>
          </el-table-column>
          <!--    <el-table-column
            prop="download_url"
            label="下载地址"
            width="210"
            align="center"
            show-overflow-tooltip
          >
            <template slot-scope="scope">
              <el-link
                type="primary"
                :underline="false"
                @click="handleToOpen(scope.row.download_url)"
                v-if="scope.row.download_url"
              >{{scope.row.download_url}}</el-link>
            </template>
          </el-table-column> -->
          <el-table-column
            prop="publish_account_names"
            label="发布账号"
            width="210"
            align="center"
            show-overflow-tooltip
          >
          </el-table-column>
          <el-table-column
            prop="part_time_name"
            label="作者"
            width="120"
            align="center"
            show-overflow-tooltip
          >
          </el-table-column>
          <el-table-column
            prop="part_time_name"
            label="兼职费用"
            width="80"
            align="center"
            show-overflow-tooltip
          >
            <template slot-scope="scope">
              {{scope.row.part_time_fee}}元
            </template>
          </el-table-column>
          <el-table-column
            prop="remark"
            label="备注"
            width="300"
            align="center"
            show-overflow-tooltip
          >
          </el-table-column>
          <el-table-column
            width="120"
            label="创建人"
            align="center"
            show-overflow-tooltip
          >
            <template slot-scope="scope">
              {{ formateCreator(scope.row.creator)}}
            </template>
          </el-table-column>
          <el-table-column
            label="创建时间"
            align="center"
            width="150"
          >
            <template slot-scope="scope">
              <span>{{
                $moment(scope.row.create_time).format("YYYY.MM.DD HH:mm")
              }}</span>
            </template>
          </el-table-column>
          <el-table-column
            label="修改时间"
            width="150"
            align="center"
          >
            <template slot-scope="scope">
              <span>{{
                $moment(scope.row.update_time).format("YYYY.MM.DD HH:mm")
              }}</span>
            </template>
          </el-table-column>
          <el-table-column
            label="操作"
            width="150"
            align="center"
            fixed="right"
          >
            <template slot-scope="scope">
              <el-link
                type="primary"
                :underline="false"
                @click="handleToOpen(scope.row.download_url)"
              >下载</el-link>
              <el-link
                type="primary"
                :underline="false"
                @click="openEditDialog(scope.row)"
              >编辑</el-link>
              <el-link
                type="danger"
                :underline="false"
                @click="handleToRemove(scope.row.id)"
              >删除</el-link>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div class="footer">
        <el-button
          size="small"
          type="danger"
          @click="handleToDeleteAll()"
        >批量删除</el-button>
        <el-pagination
          background
          layout="total, prev, pager, next, sizes, jumper"
          :current-page="Number(query.pageIndex)"
          :page-sizes="[10, 20, 50, 100, 500]"
          :page-size="Number(query.pageSize)"
          :total="Number(pageTotal)"
          @size-change="handleSizeChange"
          @current-change="handlePageChange"
        ></el-pagination>
      </div>
    </div>
    <OriginalCreate
      :visible="createDialog"
      @close="createDialog=false"
      @submit="fetchList"
    />
    <OriginalEdit
      :visible="editDialog"
      @close="editDialog=false"
      @submit="fetchList"
      :content="editContent"
    />
  </div>
</template>

<script>

import { mediawritinglist, mediawritingDestroy, mediawritinglistDestroy, mediawritingUpdate, mediawritinglistexport } from "@/api/select";
import OriginalCreate from "@/components/dialog/select/OriginalCreate";
import OriginalEdit from "@/components/dialog/select/OriginalEdit";




export default {
  components: {
    OriginalCreate,
    OriginalEdit
  },
  data() {
    return {
      query: {
        pageIndex: 1,
        pageSize: localStorage.getItem("pageSize")
          ? Number(localStorage.getItem("pageSize"))
          : 10,
        isPaging: 1,
      },
      pageTotal: 10,
      results: [],
      createDialog: false,
      editDialog: false,
      editContent: {},
      chooseList: [],
      pre_pub_time: "",
      create_time: "",
      filter: {
        publish_status: [
          { label: "全部", value: "" },
          { label: "发布", value: "1" },
          { label: "未发布", value: "0" },
        ],
      }
    };
  },
  created() {
    this.fetchList()
    this.$store.dispatch('getMediaTopicList')
    this.$store.dispatch('getAdminList')
  },
  watch: {
    // 时间数据监听
    pre_pub_time(value) {
      if (value) {
        this.query.start_pre_pub_time = this.$moment(value[0]).valueOf();
        this.query.end_pre_pub_time = this.$moment(value[1]).valueOf();
      } else {
        this.query.start_pre_pub_time = "";
        this.query.end_pre_pub_time = "";
        this.fetchList(true)
      }
    },
    // 时间数据监听
    create_time(value) {
      if (value) {
        this.query.start_create_time = this.$moment(value[0]).valueOf();
        this.query.end_create_time = this.$moment(value[1]).valueOf();
      } else {
        this.query.start_create_time = "";
        this.query.end_create_time = "";
        this.fetchList(true)
      }
    },
  },
  methods: {
    fetchList(isReset = false) {
      if (isReset) {
        this.$set(this.query, "pageIndex", 1);
      }
      mediawritinglist(this.query).then((res) => {
        this.results = res.list || [];
        this.pageTotal = res.count;
      });
      this.syncQuery();
    },
    // 分页条数变化
    handleSizeChange(val) {
      this.$set(this.query, "pageSize", val);
      localStorage.setItem("pageSize", val);
      this.fetchList();
    },
    // 分页导航
    handlePageChange(val) {
      this.$set(this.query, "pageIndex", val);
      this.fetchList();
    },
    // 触发搜索按钮
    handleSearch() {
      this.$set(this.query, "pageIndex", 1);
      this.fetchList();
    },
    // 重置搜索条件
    handleFormReset(formName) {
      this.$refs[formName].resetFields();
      this.fetchList();
    },
    // 解析URL请求参数
    parseQuery() {
      Object.keys(this.$route.query).forEach((key) => {
        this.query[key] = this.$route.query[key];
      });
    },
    // 同步URL请求参数
    syncQuery() {
      let isSync = Object.keys(this.query).some(
        (key) => this.$route.query[key] != this.query[key]
      );
      isSync &&
        this.$router.replace({
          query: Object.assign({}, this.$route.query, this.query),
        });
    },
    handleToRemove(id) {
      this.$confirm("确定要删除此条信息吗", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        mediawritingDestroy({ id }).then((res) => {
          this.$nextTick(() => {
            this.fetchList();
          });
        });
      })
    },
    formatePlatform_code(val) {
      const platform_code = {
        1: "小红书",
        2: "公众号",
        3: "微博",
        /*    4: "B站", */
        5: "知乎",
        /*   6: "抖音", */

      };
      return platform_code[val] || "";
    },
    openEditDialog(row) {
      this.editDialog = true
      this.editContent = Object.assign({}, row)
    },
    handleSelectionChange(val) {
      this.chooseList = val
    },
    handleToDeleteAll() {
      if (this.chooseList.length == 0) {
        this.$message.error('还没有选择要删除的数据')
        return
      }
      this.$confirm("确定要删除这些信息吗", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        let ids = this.chooseList.map(v => { return v.id })
        mediawritinglistDestroy({ ids }).then((res) => {
          this.fetchList();
        });
      })
    },
    formateCreator(val) {
      if (this.$store.state.adminList.length) {
        if (val) {
          if (this.$store.state.adminList.findIndex((v) => { return v.id == val }) > -1) {
            return this.$store.state.adminList.find((v) => { return v.id == val }).nickname
          } else {
            return "无"
          }
        } else {
          return "无"
        }
      }
    },
    handleToTypeset(row, status, text) {
      this.$confirm(text, "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        let query = {
          id: row.id,
          is_typeset: status,
          title: row.title,
          topic_id: row.topic_id,
        }
        mediawritingUpdate(query).then((res) => {
          this.$message.success('修改成功')
          this.fetchList();
        });
      })
    },
    handleToOpen(url) {
      try {
        let fileData = JSON.parse(url)
        this.getBlob(fileData.url, fileData.name)
      } catch (error) {
        this.getBlob(url)
      }
    },
    getBlob(imgurl, filename = '文件') {
      var ajax = new XMLHttpRequest();
      ajax.open("GET", imgurl, true);
      ajax.responseType = 'blob';
      ajax.onload = e => {
        let res = e.target.response
        let blob = new Blob([res], { type: res.type }) // 这里的res为后端返回的流数据
        if (window.navigator.msSaveOrOpenBlob) { //兼容IE10
          navigator.msSaveBlob(blob, filename)
        } else {
          const href = URL.createObjectURL(blob) //创建新的URL表⽰指定的blob对象
          const a = document.createElement('a') //创建a标签
          a.style.display = 'none'
          a.href = href // 指定下载链接
          a.download = filename //指定下载⽂件名
          a.click() //触发下载
          URL.revokeObjectURL(a.href) //释放URL对象
        }
      }
      ajax.send()
    },
    handleExport() {
      this.$confirm("是否导出数据", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        mediawritinglistexport(this.query).then((res) => {
          if (res) {
            this.$message.success('导出成功')
            //创建a标签用于跳转至下载链接
            window.open(res.url)
          }
        });
      })
    },

  },
};
</script>

<style scoped lang="less">
.client {
  .card {
    position: relative;
    color: #303133;
    background-color: #fff;
    border: 1px solid #ebeef5;
    box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
    border-radius: 4px;
    overflow: hidden;
    padding: 20px;
  }

  .table-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 100%;
  }
  .header {
    .breadcrumb {
      margin-bottom: 30px;
    }
    .title {
      font-size: 30px;
    }
    .content {
      display: flex;
      align-content: center;
      overflow-y: visible;
    }

    .left,
    .right {
      flex: 1;
    }
    .right {
      display: flex;
      justify-content: flex-end;
      align-items: center;
      text-align: center;

      .button {
        // font-size: 14px;
        // padding: 12px 20px;
      }
    }
  }

  .filters {
    margin-top: 10px;

    .search-wrap {
      margin-bottom: -18px;

      .datetime {
        width: 380px;
      }
    }
    .divider {
      border-bottom: 1px dashed #dcdfe6;
      margin: 15px 0;
    }
    .action-wrap {
      display: flex;
      justify-content: flex-end;
    }
  }
  .results {
    flex: 1;
    margin-top: 10px;

    .title {
      font-size: 20px;
      font-weight: bold;
      margin-bottom: 20px;
    }
    .values {
    }
    .footer {
      display: flex;
      justify-content: space-between;
      margin-top: 20px;
    }
  }
}
.el-link {
  font-size: 12px;
  margin: 0px 5px;
}
</style>
